import { Text, Flex, Skeleton } from "@chakra-ui/react";
import { ReactNode } from "react";

export interface TileProps {
  cardVariant?: string;
  cardDescription?: string | ReactNode;
  cardHeading?: string;
  tileBackgroundColor?: string;
  showDescription?: boolean;
  isLoaded?: boolean;
}

export const Tile = (props: TileProps) => {
  const {
    cardVariant,
    showDescription,
    cardDescription,
    cardHeading,
    tileBackgroundColor,
    isLoaded
  } = props;
  return (
    <Skeleton isLoaded={isLoaded}>
      <Flex
        minH={showDescription && cardDescription ? "162px" : "265px"}
        backgroundColor={tileBackgroundColor ? tileBackgroundColor : "teal.600"}
        h="full"
        w="full"
        padding={4}
        borderRadius="lg"
        borderBottomRadius={cardVariant === "elevated" ? "none" : "lg"}
        alignItems="center"
        justifyContent="center"
        data-testid="card-headingTile"
      >
        <Text
          fontSize="md"
          fontWeight="semibold"
          color={
            tileBackgroundColor === "gray.300"
              ? "blackAlpha.900"
              : "whiteAlpha.900"
          }
          textAlign="center"
          noOfLines={5}
          data-testid="card-headingText"
        >
          {cardHeading}
        </Text>
      </Flex>
    </Skeleton>
  );
};
